import {
  Inject,
  inject,
  Injectable,
  InjectionToken,
  Optional,
} from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
} from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { ConfigService } from '../services/config.service';
import { ErrorService } from '../services/error.service';
import { GraphQLResponse } from '../interfaces/common.interface';

enum GraphQLOperationType {
  QUERY = 'query',
  MUTATION = 'mutation',
}

export type SkipErrorHandlingOperationsList = string[];

export const SKIP_ERROR_HANDLING_OPERATIONS_LIST =
  /*@__PURE__*/ new InjectionToken<SkipErrorHandlingOperationsList>(
    'list of operations that will skip error handling in GraphqlInterceptorInterceptor'
  );

@Injectable()
export class GraphqlInterceptorInterceptor implements HttpInterceptor {
  private _configService = inject(ConfigService);
  private _errorService = inject(ErrorService);

  constructor(
    @Inject(SKIP_ERROR_HANDLING_OPERATIONS_LIST)
    @Optional()
    private operationsList?: SkipErrorHandlingOperationsList
  ) {}

  intercept(
    request: HttpRequest<GraphQLResponse>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      tap({
        next: (res: HttpResponse<GraphQLResponse>) => {
          if (
            this._configService.environment?.production &&
            request.body?.query?.startsWith(GraphQLOperationType.QUERY)
          ) {
            return;
          }

          if (this.operationsList) {
            if (this.operationsList.includes(request.body?.operationName)) {
              return;
            }
          }

          if (res.body?.errors?.length) {
            this._errorService.handleGraphQLErrors(res.body.errors);
          }
        },
      })
    );
  }
}
